import { gql } from "lib/apolloClient";

import { learningCourseItemFragment } from "./Fragments";

export const getLearningCoursesQuery = gql`
  query getLearningCourses(
    $curriculumProgramId: ID!
    $curriculumInterfaceType: ENTITY_TYPE_ENUM!
    $after: String
    $filters: LearningCourseFilters
  ) {
    node(id: $curriculumProgramId, type: $curriculumInterfaceType) {
      id
      ... on IbPypCurriculumProgram {
        id
        learningCourse(first: 50, after: $after, filters: $filters) {
          edges {
            node {
              ...learningCourseItem
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }

      ... on IbMypCurriculumProgram {
        id
        learningCourse(first: 50, after: $after, filters: $filters) {
          edges {
            node {
              ...learningCourseItem
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }

      ... on UBDCurriculumProgram {
        id
        learningCourse(first: 50, after: $after, filters: $filters) {
          edges {
            node {
              ...learningCourseItem
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }

      ... on IbDpCurriculumProgram {
        id
        learningCourse(first: 50, after: $after, filters: $filters) {
          edges {
            node {
              ...learningCourseItem
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }

      ... on GenericCurriculumProgram {
        id
        learningCourse(first: 50, after: $after, filters: $filters) {
          edges {
            node {
              ...learningCourseItem
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
  ${learningCourseItemFragment}
`;
